import 'core/brilliant_lib';
import 'core/brilliant_core';

import $ from 'jquery';
import { initGenericControllers } from 'app/generic_controllers';
import { initAutosubmit, preventDefaultSubmitHandler } from 'util/autosubmit';
import { add as addDeferredComponent } from 'util/deferred';
import { onDOMReady } from 'util/onload';


onDOMReady(() => {
    initGenericControllers();

    // deferred components

    $('.cmp-deferred').each((i, cmp) => {
        addDeferredComponent($(cmp));
    });

    // auto-submit forms via ajax

    const $ajaxForms = $('form:not(.disable-submit-auto-disabling, #_fb_login)');
    preventDefaultSubmitHandler($ajaxForms);

    $('form').each((i, form) => {
        const $form = $(form);
        if ($form.attr('action') === '') {
            $form.attr('action', window.location.href);
        }
    });
    initAutosubmit();
});
